document.addEventListener("DOMContentLoaded", function () {
var swiper = new Swiper(".banner-outerDiv", {
    loop: false,
    slidesPerView: 1,
    effect: "fade", // Smooth fade effect
    speed: 1000, // Speed of transition
    autoplay: {
        delay: 3000, // Auto-slide change every 3 seconds
        disableOnInteraction: false,
    },
    on: {
        slideChangeTransitionStart: function () {
            // Remove animation class from all slides
            document.querySelectorAll(".banner-content-header").forEach(el => {
                el.classList.remove("animate-text");
            });
        },
        slideChangeTransitionEnd: function () {
            // Add animation class to the active slide's text
            let activeSlide = document.querySelector(".swiper-slide-active .banner-content-header");
            if (activeSlide) {
                activeSlide.classList.add("animate-text");
            }
        }
    }
});


var swiper = new Swiper(".collectionImages-blocks", {
      slidesPerView: 4.5,
      spaceBetween: 12,
       loop: true,
   simulateTouch: true,
  grabCursor: true,
       navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    breakpoints: {
        480: {
            slidesPerView: 4.5,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 6,
        },
        980: {
            slidesPerView: 8,
        },
        1280: {
            slidesPerView: 11,
          
         
        }
    },
    });
  var swiper = new Swiper('.testimonial-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
     navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.testimonial-container .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
        480: {
            slidesPerView: 1,
            navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
        },
        768: {
            slidesPerView: 1,
        },
        980: {
            slidesPerView: 3,
        },
        1280: {
            slidesPerView: 4,
        }
    },
  });
  var swiper = new Swiper(".article-blog-slider", {
      slidesPerView: 1,
      spaceBetween: 20,
       navigation: {
       nextEl: ".article-next",
        prevEl: ".article-prev",
      },
     breakpoints: {
        480: {
            slidesPerView: 1,
            spaceBetween: 20,
          
        },
        768: {
            spaceBetween: 20,
            slidesPerView: 2,
        },
        980: {
            slidesPerView: 2,
        },
        1280: {
            slidesPerView: 4,
        }
    },
    });



    const tabs = document.querySelectorAll(".product-tabs-heading a");
    const contents = document.querySelectorAll(".product-tabs-content");
  
    if (tabs.length > 0) {
      tabs[0].classList.add("active");
      contents[0].style.display = "block";
  
      tabs.forEach((tab) => {
        tab.addEventListener("click", function (e) {
          e.preventDefault();
  
          let target = this.getAttribute("data-tab");
  
          tabs.forEach((t) => t.classList.remove("active"));
          this.classList.add("active");
  
          contents.forEach((content) => {
            content.style.display = content.classList.contains(target) ? "block" : "none";
          });
        });
      });
    }

  const faqItems = document.querySelectorAll(".faqInnerBk");

  faqItems.forEach((item, index) => {
    const question = item.querySelector(".faq-outerDiv");
    const answer = item.querySelector(".faq-answer");
    const toggleIcon = item.querySelector(".toggle-icon");

    if (index !== 0) {
      answer.style.display = "none";
      toggleIcon.textContent = "+";
    } else {
      answer.style.display = "block";
      toggleIcon.textContent = "−"; 
    }

    question.addEventListener("click", function () {
      const isOpen = answer.style.display === "block";

      faqItems.forEach((faq) => {
        faq.querySelector(".faq-answer").style.display = "none";
        faq.querySelector(".toggle-icon").textContent = "+";
      });

      answer.style.display = isOpen ? "none" : "block";
      toggleIcon.textContent = isOpen ? "+" : "−";
    });
  });

  const readMoreToggle = document.querySelector('[data-toggle-read-more]');
  const descriptionWrapper = document.querySelector('.product__description-wrapper, .page-description');
  
  if (readMoreToggle && descriptionWrapper) {
  
    readMoreToggle.addEventListener('click', () => {
      descriptionWrapper.classList.toggle('expanded');
  
      if (descriptionWrapper.classList.contains('expanded')) {
        readMoreToggle.innerHTML = 'Read Less';
      } else {
        readMoreToggle.innerHTML = 'Read More ';
      }
    });
  }

  var currentPath = window.location.pathname;
  var blocks = document.querySelectorAll('.custom-block');

  blocks.forEach(function(block) {
    var blockUrl = block.getAttribute('data-block-url');
    if (blockUrl && currentPath.includes(blockUrl)) {
      block.querySelector('.block-title h4').classList.add('highlight');
    }
  });

      function toggleFooterOnMobile() {
      if (window.innerWidth <= 1024) { 
        document.querySelectorAll(".open-toggle").forEach(el => el.style.display = "none");
    
        document.querySelectorAll(".menu-toggle").forEach(heading => {
          heading.removeEventListener("click", toggleContent); 
          heading.addEventListener("click", toggleContent);
        });
      } else {
        document.querySelectorAll(".open-toggle").forEach(el => el.style.display = "block");
      }
    }
    
    function toggleContent() {
      let content = this.nextElementSibling;
      
      if (content.style.display === "block") {
        content.style.display = "none";
        this.removeAttribute("open");
      } else {
        content.style.display = "block";
        this.setAttribute("open", "true");
      }
    }
    
    toggleFooterOnMobile();
    window.addEventListener("resize", toggleFooterOnMobile); 


  
});

document.addEventListener("click", function (e) {
  const button = e.target.closest(".offer_code");
  if (!button) return; // exit if not clicked on .offer_code

  const copiedText = button.getAttribute("data-clipboard-text");
  const copiedStatus = button.querySelector(".copyStatus");

  copyToClipboard(copiedText);

  if (copiedStatus) {
    copiedStatus.textContent = "Copied!";
    copiedStatus.style.display = "inline-block";

    setTimeout(() => {
      copiedStatus.style.display = "none";
    }, 1500);
  }
});

function copyToClipboard(text) {
  const tempTextArea = document.createElement("textarea");
  tempTextArea.value = text;
  document.body.appendChild(tempTextArea);
  tempTextArea.select();
  document.execCommand("copy");
  document.body.removeChild(tempTextArea);
}
